import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl, defineMessages} from 'react-intl';
import Season from './Season';
import './spring.svg';
import './summer.svg';
import './autumn.svg';
import './winter.svg';

export const messages = defineMessages({
    title: {id: 'module.destination.infographic.weather.heading'},
    spring: {id: 'module.destination.infographic.weather.spring.heading'},
    summer: {id: 'module.destination.infographic.weather.summer.heading'},
    autumn: {id: 'module.destination.infographic.weather.autumn.heading'},
    winter: {id: 'module.destination.infographic.weather.winter.heading'},
    high: {id: 'module.destination.infographic.weather.subheading.high'},
    low: {id: 'module.destination.infographic.weather.subheading.low'},
    precipitation: {id: 'module.destination.infographic.weather.subheading.precipitation'}
});

const mapStateToProps = (state) => ({
    seasons: state.destination.infographic.weather.seasons
});

export class WeatherComponent extends Component {
    render() {
        const {intl, seasons = {}} = this.props;
        const seasonsArr = ['spring', 'summer', 'autumn', 'winter'];
        if (Object.keys(seasons) < 4) {
            return null;
        }
        return (
            <div className="weather">
                <h3 className="weather__heading">{intl.formatMessage(messages.title)}</h3>
                <div className="weather__items">
                    {seasonsArr.map((item, index) => {
                        const {
                            maxTemp, maxTempAmount, maxTempUnit,
                            minTemp, minTempAmount, minTempUnit,
                            precipitation: precipitationPercentage, precipitationAmount, precipitationUnit
                        } = seasons[item];
                        const precipitation = intl.formatMessage(messages.precipitation, {
                            precipitationPercentage,
                            precipitationAmount,
                            precipitationUnit
                        });
                        const icon = item;
                        const heading = intl.formatMessage(messages[item]);
                        const high = intl.formatMessage(messages.high, {
                            'localizedHighTemperature': maxTemp,
                            maxTempAmount,
                            maxTempUnit
                        });
                        const low = intl.formatMessage(messages.low, {
                            'localizedLowTemperature': minTemp,
                            minTempAmount,
                            minTempUnit
                        });
                        return <Season key={index} {...{heading, icon, high, low, precipitation}} />;
                    })}
                </div>
            </div>
        );
    }
}

export const Weather = injectIntl(
    connect(mapStateToProps)(WeatherComponent)
);
export default Weather;